export default {
  isLogged: false,
  displayName: '',
  firstName: '',
  lastName: '',
  email: '',
  credentials: []
}
